/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { HTMLAttributes, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, space, spacing } from '@airwallex/global';
import { Headline } from '@airwallex/typography';
import AirwallexLogo from '@/assets/svgs/airwallexLogoFull';
import PowerByAirwallex from '@/assets/svgs/powerByAirwallex.svg';
import LanguageSelect from './languageSelect';

const { darkGrey, greys } = colors;

export type WidescreenProps = {
  logoUrl?: string;
  haveLanguageChoice?: boolean;
  hideBorder?: boolean;
  isXeroInvoice?: boolean;
};

export const selectCss = css`
  width: 160px;
  height: 40px;
  margin-left: 8px;
`;

export const Index: React.FC<WidescreenProps & HTMLAttributes<HTMLDivElement>> = ({
  haveLanguageChoice,
  hideBorder,
  isXeroInvoice,
}) => {
  const { t } = useTranslation();
  return (
    <div
      css={css`
        height: ${haveLanguageChoice ? '64px' : '56px'};
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        ${!hideBorder && `box-shadow: inset 0px -1px 0px ${greys[20]};`}
        z-index: 1000;
      `}
    >
      <h5
        css={css`
          color: ${darkGrey};
          margin: 0 auto;
          padding: 0 ${spacing.xxl}px;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: ${haveLanguageChoice ? '64px' : '56px'};
          `}
        >
          <div
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
              column-gap: ${space.s};
            `}
          >
            {isXeroInvoice ? (
              <Fragment>
                <AirwallexLogo width={117} height={16} />
                <div
                  css={css`
                    width: 1px;
                    height: 24px;
                    background-color: ${greys[20]};
                  `}
                />
                <Headline variant="200">{t('invoice.header')}</Headline>
              </Fragment>
            ) : (
              <PowerByAirwallex />
            )}
          </div>
          {haveLanguageChoice && <LanguageSelect css={selectCss} />}
        </div>
      </h5>
    </div>
  );
};

export default Index;
